<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import ColorPickerDropdown from '@/core/elements/ColorPickerDropdown.vue';
import { EPosition } from 'common/enum/misc.enum';
import { computed } from 'vue';
import { APPEARANCE_COLORS } from '../appearance.constants';

const { t } = useI18n();

defineProps<{ modelValue: string }>();
const emit = defineEmits<{ 'update:modelValue': [color: string] }>();
const colors = computed(() =>
  APPEARANCE_COLORS.map((color) => ({ value: color.value, label: t(`entityAppearance.colors.${color.key}`) })),
);
</script>

<template>
  <div
    class="flex h-[70px] shrink-0 items-center justify-between border-t border-divider px-[20px] text-body leading-body text-secondary"
  >
    <span>{{ t('entityAppearance.background') }}</span>
    <ColorPickerDropdown
      :model-value="modelValue"
      :colors="colors"
      :label="t('entityAppearance.background')"
      compact
      :position="EPosition.BOTTOM_RIGHT"
      :offset-y="8"
      flip-strategy="both"
      @update:model-value="emit('update:modelValue', $event)"
    />
  </div>
</template>
